export class RestoreAzureFileShareRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recoveryPointId",
            "baseName": "recoveryPointId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreRequestType",
            "baseName": "restoreRequestType",
            "type": "RestoreAzureFileShareRequestRestoreRequestTypeEnum",
            "format": ""
        },
        {
            "name": "recoveryType",
            "baseName": "recoveryType",
            "type": "RestoreAzureFileShareRequestRecoveryTypeEnum",
            "format": ""
        },
        {
            "name": "sourceStorageAccountId",
            "baseName": "sourceStorageAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultName",
            "baseName": "vaultName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultResourceGroup",
            "baseName": "vaultResourceGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetStorageAccountId",
            "baseName": "targetStorageAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetFileShareName",
            "baseName": "targetFileShareName",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetFolderPath",
            "baseName": "targetFolderPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreFileSpecs",
            "baseName": "restoreFileSpecs",
            "type": "Array<AzureFileShareRestoreFileSpec>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAzureFileShareRequest.attributeTypeMap;
    }
    constructor() {
    }
}
export var RestoreAzureFileShareRequestRestoreRequestTypeEnum;
(function (RestoreAzureFileShareRequestRestoreRequestTypeEnum) {
    RestoreAzureFileShareRequestRestoreRequestTypeEnum["FullShareRestore"] = "FullShareRestore";
    RestoreAzureFileShareRequestRestoreRequestTypeEnum["ItemLevelRestore"] = "ItemLevelRestore";
})(RestoreAzureFileShareRequestRestoreRequestTypeEnum || (RestoreAzureFileShareRequestRestoreRequestTypeEnum = {}));
export var RestoreAzureFileShareRequestRecoveryTypeEnum;
(function (RestoreAzureFileShareRequestRecoveryTypeEnum) {
    RestoreAzureFileShareRequestRecoveryTypeEnum["OriginalLocation"] = "OriginalLocation";
    RestoreAzureFileShareRequestRecoveryTypeEnum["AlternateLocation"] = "AlternateLocation";
})(RestoreAzureFileShareRequestRecoveryTypeEnum || (RestoreAzureFileShareRequestRecoveryTypeEnum = {}));
